import { polyfill } from 'es6-object-assign'
polyfill()

import Vue from 'vue/dist/vue.esm'
import Vue2TouchEvents from 'vue2-touch-events'
import ExpandableItem from '../vue-components/expandable-item/ExpandableItem'
import FlashMessage from '../vue-components/notifications/FlashMessage'
import Tooltip from '../vue-components/tooltip/Tooltip'


export const initiateVue = (components, store) => {

  Vue.prototype.$eventHub = new Vue()

  document.addEventListener('DOMContentLoaded', () => {
    Vue.use(Vue2TouchEvents)
    const options = {
      el: '#vue-app',
      components: { ExpandableItem, FlashMessage, Tooltip, ...components }
    }

    if (store) { options.store = store }

    new Vue(options)
  })
}